module.exports = __webpack_public_path__ + "img/elantra2.2a96593d.jpeg";